import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postMatchmakerSkip,
  type PostMatchmakerSkipParams,
  type PostMatchmakerSkipResponse,
} from '@services/MatchmakerService';

export type UsePostMatchmakerSkipParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostMatchmakerSkipResponse,
    unknown,
    string,
    PostMatchmakerSkipParams,
    PostMatchmakerSkipResponse
  >;
};

export const postMatchmakerSkipMutationKey = 'post-matchmaker-skip';

export const usePostMatchmakerSkip = ({
  mutationOptions,
}: UsePostMatchmakerSkipParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostMatchmakerSkipResponse,
    unknown,
    string,
    PostMatchmakerSkipParams
  >(
    postMatchmakerSkipMutationKey,
    (_url, { arg }) => postMatchmakerSkip(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
